export default function Button({ variant = 'primary', tone = 'default', className = '', type = 'button', children, ...props }) {
  const toneClass = tone !== 'default' ? ` sb-btn--${tone}` : ''
  return (
    <button
      {...props}
      type={type}
      className={`sb-btn sb-btn-${variant}${toneClass}${className ? ` ${className}` : ''}`}
    >
      {children}
    </button>
  )
}
